module.exports = __webpack_public_path__ + "img/lv16.be433f54.png";